// Module
var code = "<template>\n    <input focus.bind=\"inFocus\" focus.trigger=\"triggerFocus()\" autocomplete=\"off\" disabled.bind=\"disabled\" type=\"text\" empty.bind=\"empty\" value.one-way=\"dateString\" class=\"au-datepicker\" change.delegate=\"inputChanged($event)\">\n</template>\n";
// Exports
export default code;